export enum ICON_NAME {
  MicOn = 'mic-on',
  MicOff = 'mic-off',
  MicOffDisabled = 'mic-off-gray',
  CameraOn = 'camera-on',
  CameraOff = 'camera-off',
  CameraOffDisabled = 'camera-off-gray',
  ArrowBorderDown = 'arrow-border-down',
  ScreenSharing = 'screen-sharing',
  ScreenShare = 'screen-share',
  ScreenShareStopped = 'screen-share-stopped',
  ScreenShareDisabled = 'screen-share-disabled',
  ChatActive = 'chat-active',
  Chat = 'chat',
  ExitFullScreen = 'exit-fullscreen',
  FullScreen = 'full-screen',
  InviteActive = 'invite-active',
  Invite = 'invite',
  ManageMemberActive = 'manage-member-active',
  ManageMember = 'manage-member',
  More = 'more',
  MoreActive = 'more-active',
  SettingActive = 'setting-active',
  Setting = 'setting',
  voteActive='vote-active',
  Vote='vote',
  LineArrowUp = 'line-arrow-up',
  LineArrowDown = 'line-arrow-down',
  ApplyOnSeat = 'apply',
  ApplyActive = 'apply-active',
  GoOffSeat = 'go-off-seat',
}
